import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';

const reducers = combineReducers({
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
});

export default reducers;
